import { render } from "./ContentCard.vue?vue&type=template&id=11460e32&scoped=true"
import script from "./ContentCard.vue?vue&type=script&lang=ts"
export * from "./ContentCard.vue?vue&type=script&lang=ts"

import "./ContentCard.vue?vue&type=style&index=0&id=11460e32&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11460e32"

export default script